// TODO design this page
export const NotFoundPage = () => {
  return <div>Page not found!</div>;
};
